export enum RegistrationTypeEnum {
	NormalRegistration = "Normal",
	MitIdRegistration = "MitId",
	BankIdRegistration = "BankId",
	TerminalRegistration = "Terminal",
	PartnerRegistration = "Partner",
}
